/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_To_ConnectInputs */

const en_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish work to Connect`)
};

const fr_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier sur Connect`)
};

const de_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen Sie Ihre Arbeit auf Connect`)
};

const it_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica il lavoro su Connect`)
};

const ru_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликуйте свою работу в Connect.`)
};

const es_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar trabajo en Connect`)
};

const zh_cn2_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将作品发布到 Connect`)
};

const ja_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectに作品を公開する`)
};

const hi_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनेक्ट पर काम प्रकाशित करें`)
};

const pt_pt2_publish_to_connect = /** @type {(inputs: Publish_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publique seu trabalho no Connect`)
};

/**
* | output |
* | --- |
* | "Publish work to Connect" |
*
* @param {Publish_To_ConnectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish_to_connect = /** @type {((inputs?: Publish_To_ConnectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_To_ConnectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_publish_to_connect(inputs)
	if (locale === "de") return de_publish_to_connect(inputs)
	if (locale === "it") return it_publish_to_connect(inputs)
	if (locale === "ru") return ru_publish_to_connect(inputs)
	if (locale === "es") return es_publish_to_connect(inputs)
	if (locale === "zh-CN") return zh_cn2_publish_to_connect(inputs)
	if (locale === "ja") return ja_publish_to_connect(inputs)
	if (locale === "hi") return hi_publish_to_connect(inputs)
	if (locale === "pt-PT") return pt_pt2_publish_to_connect(inputs)
	return en_publish_to_connect(inputs)
});